import React from 'react'

// Context
import { ProgressContext } from 'Contexts/ProgressContext'

// Hooks
import { usePrevious } from 'hooks'

const useProgress = (hasData, fetchingData) => {
  const [initialized, setInitialized] = React.useState(false)
  const { showProgress, setShowProgress } = React.useContext(ProgressContext)
  const prevFetchingData = usePrevious(fetchingData)

  React.useLayoutEffect(() => {
    if (hasData) {
      setInitialized(true)
    }

    if (prevFetchingData && !fetchingData && !initialized) {
      setInitialized(true)
    }
    if (fetchingData) {
      setShowProgress(true)
    } else if (initialized && !fetchingData) {
      setShowProgress(false)
    }
    return () => {
      setShowProgress(false)
    }
  }, [hasData, initialized, fetchingData, prevFetchingData, setShowProgress])

  return { initialized, setShowProgress, showProgress }
}

export default useProgress
